module.exports = __webpack_public_path__ + "static/media/img_school.70326d66.jpg";